// extracted by mini-css-extract-plugin
export default {"tupacGrid":"kl-z","tupacHeader":"ll-z","tupacHeader2":"ml-z","tupacMenu":"nl-z","tupacMenu2":"ol-z","tupacMain":"pl-z","tupacMain2":"ql-z"};